module.exports = __webpack_public_path__ + "img/u4_shenmiziguan.6157710d.jpg";